export default __webpack_public_path__ + "static/media/chevron-right.bf82a47e.svg";